import { useAuthData } from '@auth/features/auth';
import {
  DEFAULT_LOGO_KEY,
  resolveOrgLogoKey,
} from '@travel-planner/shared/utils/branding';
import { uploadthingFileUrl } from '@travel-planner/uploadthing/client';

// Resolved CDN URL of the brand default — used as the sidebar `<img>` onError
// fallback so a logo always renders even when an org's stored logo key is
// broken (deleted file, wrong app, or a format the browser can't decode, e.g.
// AVIF in older Safari), which the bare UTFS CDN surfaces as a 4xx/decode fail.
export const DEFAULT_LOGO_URL = uploadthingFileUrl(DEFAULT_LOGO_KEY);

// Resolves the active organization's logo to a CDN URL (`resolveOrgLogoKey`:
// settings, then the legacy column, then the brand default).
export const useOrgLogoUrl = (): string => {
  const { data: authData } = useAuthData();
  const org = authData?.organization;
  return uploadthingFileUrl(resolveOrgLogoKey(org ?? {}));
};
